function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState, forwardRef, memo } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../../Button';
import { TYPES } from '../../../constants';
import { TextInput } from '../TextInput';
import Eye from '@dtsl/icons/dist/icons/react/Eye';
import EyeOff from '@dtsl/icons/dist/icons/react/EyeOff';

// eslint-disable-next-line react/display-name
const Password = /*#__PURE__*/forwardRef((props, ref) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const {
    actions = []
  } = props;
  const handlePasswordVisibility = e => {
    e.preventDefault();
    setIsPasswordVisible(prevVal => !prevVal);
    if (actions[0]?.onClick) {
      actions[0]?.onClick();
    }
  };
  const passwordActions = [() =>
  /*#__PURE__*/
  // eslint-disable-next-line data-test/onClick
  React.createElement(Button, _extends({}, actions[0], {
    iconAlone: true,
    variant: "tertiary",
    size: "small",
    icon: isPasswordVisible ? /*#__PURE__*/React.createElement(EyeOff, {
      height: 16,
      width: 16,
      color: "#000"
    }) : /*#__PURE__*/React.createElement(Eye, {
      height: 16,
      width: 16,
      color: "#000"
    }),
    onClick: handlePasswordVisibility
  }))];
  return /*#__PURE__*/React.createElement(TextInput, _extends({}, props, {
    ref: ref,
    prefix: null,
    suffix: null,
    type: isPasswordVisible ? TYPES.TEXT : TYPES.PASSWORD,
    actions: passwordActions,
    maxCharCount: null // maxCharCount is not applicable with type="password"
  }));
});
Password.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object)
};
export default /*#__PURE__*/memo(Password);